const Invitation = {
    user_mail: '',
    invited_till: '',
    caps: []
}

export default Invitation;